import { render } from "./CommonSocials.vue?vue&type=template&id=0c5fa800&scoped=true"
import script from "./CommonSocials.vue?vue&type=script&lang=js"
export * from "./CommonSocials.vue?vue&type=script&lang=js"

import "./CommonSocials.vue?vue&type=style&index=0&id=0c5fa800&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5fa800"]])

export default __exports__